module.exports = __webpack_public_path__ + "img/info-fullGrey.9c5d1f7f.svg";